// client/src/utils/analytics.js
// Lightweight GA4 integration using gtag.js without extra deps

const GA_SRC_BASE = "https://www.googletagmanager.com/gtag/js?id=";
let initializedId = null;

export function initAnalytics(measurementId) {
  if (!measurementId) return;

  if (initializedId === measurementId) return; // already initialized

  // Inject the gtag.js script if not present
  const scriptId = `gtag-js-${measurementId}`;
  if (!document.getElementById(scriptId)) {
    const script = document.createElement("script");
    script.async = true;
    script.src = `${GA_SRC_BASE}${encodeURIComponent(measurementId)}`;
    script.id = scriptId;
    document.head.appendChild(script);
  }

  // Set up dataLayer and gtag function
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  }
  // Expose globally (idempotent)
  window.gtag = window.gtag || gtag;

  window.gtag("js", new Date());
  // Disable the automatic first page_view; we'll control SPA views
  window.gtag("config", measurementId, { send_page_view: false });

  initializedId = measurementId;
}

export function trackPageView(path) {
  const id = initializedId;
  if (!id || typeof window.gtag !== "function") return;

  window.gtag("event", "page_view", {
    page_path: path || window.location.pathname + window.location.search,
    page_location: window.location.href,
    page_title: document.title,
  });
}

export function trackEvent(action, params = {}) {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", action, params);
}

